import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { routes } from '../../app/router/routes';

export const useCurrentKey = () => {
  const { pathname } = useLocation();
  const [currentKey, setCurrentKey] = useState();

  useEffect(() => {
    if (!pathname) return;

    Object.entries(routes).forEach(([routeName, route]) => {
      if (pathname === route.url) {
        setCurrentKey(routeName);
      }
    });
  }, [pathname]);

  return [currentKey];
};
